export enum CampaignTypeEnum {
  INO = 'INO',
  IDO = 'IDO',
}